/* eslint-disable */
<template>
  <Modal :visible="creditModal2" :footer="null" :destroyOnClose="true" wrap-class-name="empty-modal"
    @ok="creditModal2 = false" @cancel="creditModal2 = false">
    <div>
      <h1>Change status</h1>
      <h2>Ticket #{{ ticketShow?.ticket }}</h2>
      <Select v-model:value="targetStatus" @input="handleChangeStatus" class="text-center w-full mt-2" allowClear
        placeholder="Select status">
        <select-option v-for="status, index in statues" :key="index" :value="status">{{
          status
          }}</select-option>
      </Select>
      <Row class="gap-1 mt-2">
        <Col :span="10" class="m-auto">
        <Button type="primary" class="rounded w-full btn-error  flex justify-center  shadow m-auto items-center "
          @click="creditModal2 = false">
          Cancel
        </Button>
        </Col>
        <Col :span="10" class="m-auto">
        <Button type="primary" class="rounded w-full btn-warning  flex justify-center  shadow m-auto items-center "
          @click="changeStatus">
          Change status
        </Button>
        </Col>

      </Row>
    </div>
  </Modal>
  <Modal :visible="creditModal" :footer="null" :destroyOnClose="true" wrap-class-name="empty-modal"
    @ok="creditModal = false" @cancel="creditModal = false">
    <div>

      <h1>Ticket #{{ ticketShow?.ticket }}</h1>
      <h3>Owner : {{ ticketShow?.employee_name }}</h3>
      <h4>Subject : {{ ticketShow?.subject }} </h4>
      <h3>Feedback :</h3>
      <p>{{ ticketShow?.feedback }}</p>
      <br />
      <Row class="gap-1">
        <Col :span="10" class="m-auto">
        <Button type="primary" class="rounded w-full btn-error  flex justify-center  shadow m-auto items-center "
          @click="creditModal = false">
          Cancel
        </Button>
        </Col>
        <Col :span="10" class="m-auto">
        <Button type="primary" class="rounded w-full btn-warning  flex justify-center  shadow m-auto items-center "
          @click="openTicket3">
          Change status
        </Button>
        </Col>

      </Row>
    </div>
  </Modal>
  <section class="members-data">
    <div class="flex flex-wrap justify-between items-center gap-6">
      <div>
        <InputSearch class="rounded-md min-w-[320px]" placeholder="Search by ticket name" v-model:value="search" clear
          @input="handleSearch" />
      </div>
      <div>
        <Select v-model:value="searchStatus" @input="handleSearchStatus" class="text-center min-w-[300px]" allowClear
          placeholder="Select status">
          <select-option v-for="status, index in statues" :key="index" :value="status">{{
            status
          }}</select-option>
        </Select>
      </div>
    </div>
    <div class="mt-2 md:mt-3 lg:mt-4">
      {{ ticketObj?.ticket }}
      <Table :data-source="tableFormatedData" :columns="columns" :loading="ticketsQuery?.isFetching"
        :pagination="false">
        <template #bodyCell="{ column, record }">

          <template v-if="column.key === 'employee_name'">
            <span v-if="record?.employee_name" class="whitespace-nowrap w-full flex justify-center">{{
              record?.employee_name }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'status'">
            <span v-if="record?.status" class="whitespace-nowrap w-full flex justify-center">{{ record?.status }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'ticket'">
            <span v-if="record?.ticket" class="whitespace-nowrap w-full flex justify-center">{{ record?.ticket }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'date'">
            <span v-if="record?.date" class="whitespace-nowrap w-full flex justify-center">{{ record?.date }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'community'">
            <span v-if="record?.community" class="whitespace-nowrap w-full flex justify-center">{{ record?.community
              }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'subject'">
            <span v-if="record?.subject" class="whitespace-nowrap w-full flex justify-center">{{ record?.subject
              }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'message'">
            <span v-if="record?.feedback" class="whitespace-nowrap w-full flex justify-center">{{
              (record?.feedback?.length ?? 0) > 10 ?
                `${record?.feedback?.substr(0, 10)}...` : record?.feedback }}</span>
            <span v-else class="w-full flex  justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'action'">
            <span class="flex gap-0">
              <Button type="primary" size="small" title="Decline"
                class="btn-success rounded  flex justify-center  shadow m-auto items-center" :loading="statusLoading"
                @click="openTicket(record)">
                <PhFile weight="duotone" :size="16" /> View
              </Button>
              <Button type="primary" size="small" title="Decline"
                class="btn-warning rounded  flex justify-center  shadow m-auto items-center "
                @click="openTicket2(record)" :loading="statusLoading">
                <PhFile weight="duotone" :size="16" /> Change status
              </Button>
            </span>
          </template>
        </template>
      </Table>

      <div v-if="ticketsQuery && ticketsQuery.data" class="mt-6 flex items-center justify-center">
        <Pagination :current="ticketsQuery?.data?.current_page" :total="ticketsQuery?.data?.total" show-less-items
          @change="handlePaginationChange" :page-size="10" />
      </div>
    </div>
    <!-- query apis  -->
    <TicketsQuery :page="page" :per_page="15" :search="search" :search_status="searchStatus"
      :key="`${page}-${15}-${search}-${searchStatus}`" />
  </section>
</template>
<script>
/* eslint-disable */
import {
  Table,
  InputSearch,
  Select,
  Spin,
  DatePicker,
  Pagination,
  Popconfirm,
  Button,
  Modal,
  Row,
  Col,
  message,
} from 'ant-design-vue';
import dayjs from 'dayjs';

import TicketsQuery from '@/services/queries/admin/tickets/TicketsQuery.vue';

// import handleResErrors from '@/utils/handleResErrors';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';

import { PhCheck, PhFile, PhFilePdf, PhProhibit, PhTrash, PhX } from 'phosphor-vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import debounce from 'lodash.debounce';
import ticketsApi from '@/services/apis/admin/tickets.api';

export default {
  components: {
    Table,
    PhCheck,
    PhFilePdf,
    PhProhibit,
    Row,
    Col,
    CustumInput,
    Modal,
    PhTrash,
    PhX,
    InputSearch,
    PhFilePdf,
    PhFile,
    Select,
    Popconfirm,
    Spin,
    Button,
    DatePicker,
    CustumSelect,
    Pagination,
    TicketsQuery
  },
  data() {
    return {
      columns: [
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
        },
        {
          title: 'Ticket',
          dataIndex: 'ticket',
          key: 'ticket',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: 'Owner',
          dataIndex: 'employee_name',
          key: 'employee_name',
        },
        {
          title: 'Community',
          dataIndex: 'community',
          key: 'community',
        },
        {
          title: 'Subject',
          dataIndex: 'subject',
          key: 'subject',
        },
        {
          title: 'Message',
          dataIndex: 'message',
          key: 'message',
        },
        {
          title: '',
          dataIndex: 'action',
          key: 'action',
        },
      ],

      tableData: [
      ],
      statues: [
        'In Progress',
        'Backlog',
        'Resolved'
      ],
      search: '',
      searchData: [],
      page: 1,
      pageSize: 10,
      employer_id: null,
      type: 'year',
      searchStatus: null,
      targetStatus: null,
      addCreditLoading: false,
      ticketShow: null,
      years: [],
      dateData: [
        // { id: 1, name: 'custom date' },
        { id: 'month', name: 'Monthly' },
        { id: 'year', name: 'Yearly' },
        { id: 'all', name: 'All Data' },
      ],
      statusData: [
        // { id: 1, name: 'custom date' },
        { id: 'pending', name: 'pending' },
        { id: 'approved', name: 'approved' },
        { id: 'rejected', name: 'rejected' },
      ],
      dateVal: dayjs(new Date().getFullYear() + '/12', 'YYYY/MM'),
      keyword: '',
      pdfLoading: false,
      rejectionMsg: '',
      creditModal: false,
      creditModal2: false,
      modalUserId: null,
      detailsLoading: false,
    };
  },
  computed: {
    dates() {
      if (!this.dateVal) return [null, null];
      if (this.type === 'month') {
        const start = dayjs(this.dateVal).startOf('month').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('month').format('YYYY-MM-DD');
        return [start, end];
      }

      if (this.type === 'year') {
        const start = dayjs(this.dateVal).startOf('year').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('year').format('YYYY-MM-DD');
        return [start, end];
      }

      return [null, null];
    },
    ticketsQuery() {
      return this.$store.state.tickets.ticketsQuery;
    },
    tableFormatedData() {
      // if (!this.ticketsQuery || !this.ticketsQuery.data) return [];

      const data = this?.ticketsQuery?.data?.data?.map((d, ix) => ({
        key: d?._id || ix,
        employee_name: d?.user?.name,
        community: d?.user?.leader?.community?.community_name,
        ticket: d?.ticket_number,
        status: d?.status?.toUpperCase(),
        date: d?.created_at.split('T')[0],
        subject: d?.subject,
        feedback: d?.feedback,
      }));
      return data;
    },
  },
  methods: {
    handleSearch(e) {
      this.debounceSearch(e.target.value, this);
    },
    handleSearchStatus(e) {
      this.searchStatus = e.target.value;
      this.page = 1;
    },
    handleChangeStatus(e) {
      this.targetStatus = e.target.value;

    },
    async changeStatus() {
      // this.statusLoading = true;
      try {
        const id = this.ticketShow?.key;
        const status = this.targetStatus;
        const res = await ticketsApi.changeTicketStatus({ id, status });
        message.success('Status updated successfully');

        this.creditModal2 = false;
        this.targetStatus = null;
        if (this.ticketsQuery) {
          await this.ticketsQuery.refetch();
        }
      } catch (error) {
        message.error(handleResErrors(error), 10);
      } finally {
        // this.statusLoading = false;
      }
    },
    debounceSearch: debounce((search, app) => {
      // eslint-disable-next-line no-param-reassign
      app.search = search;
      // eslint-disable-next-line no-param-reassign
      app.page = 1;
    }, 400),
    handlePaginationChange(page) {
      // , filters, sorter, data
      this.page = page;
    },
    openTicket(ticketObj) {
      this.creditModal = true;
      this.ticketShow = ticketObj;
    },
    openTicket2(ticketObj) {
      this.ticketShow = ticketObj;
      this.creditModal2 = true;
    },
    openTicket3() {
      this.creditModal = false;
      this.creditModal2 = true;
    }
  },
};
</script>
